module.exports = __webpack_public_path__ + "static/ACCEPTED-5ca794d8d05d8c6fbdbd5cb787362893.png";